export default __webpack_public_path__ + "../staticImages/error404Desktop.webp";